'use client';

import { useEffect } from 'react';

import { utilEventElementVisibility } from '@/fo/util/event-element-visibility';

import { useStickyVisibility } from '../hooks/useStickyVisibility';

export const EVENT_NAME_SHOW_STICKY_HEAD = 'show-sticky-head';
export const EVENT_NAME_HIDE_STICKY_HEAD = 'hide-sticky-head';

export function SentinelForHeadFixed() {
  const { rootRef, showSticky } = useStickyVisibility();

  useEffect(() => {
    if (showSticky) {
      utilEventElementVisibility.show(EVENT_NAME_SHOW_STICKY_HEAD);
    } else {
      utilEventElementVisibility.hide(EVENT_NAME_HIDE_STICKY_HEAD);
    }
  }, [showSticky]);

  return (
    <div
      ref={rootRef}
      style={{
        width: '1px',
        height: '1px',
        opacity: 0,
        pointerEvents: 'none'
      }}
    />
  );
}
